@let isReadonly = isReadonly$ | async;

<div class="se-side-image-preview-items-container">
    @if (keyImages.length) {
        <div class="se-draggable-list-2">
            <!-- TODO: è possibile fare il tracking per SOPInstanceUID? -->
            @for (item of keyImages; track $index) {
                <div class="se-draggable-img-preview-2">
                    <se-side-key-images-item
                        [keyImageObject]="item"
                        [readonly]="isReadonly"
                        (deleteImageEvent)="showModal($event)"
                        (updateStateEvent)="updateState($event)"
                    ></se-side-key-images-item>
                </div>
            }
        </div>
    } @else {
        <div class="se-side-key-images-text-container">
            <span>{{ sideKeyImagesMessage }}</span>
        </div>
    }

    @if (isLoading | async) {
        <div class="estensa-spinner">
            <mat-spinner></mat-spinner>
        </div>
    }
</div>

<div class="se-side-key-toolbar-container">
    <mat-form-field class="image-row-count-field" appearance="outline">
        <mat-label [matTooltip]="'ImageKey_ImageRowCount' | translate">
            {{ "ImageKey_ImageRowCount" | translate }}
        </mat-label>

        <mat-select
            [placeholder]="'ImageKey_ImageRowCount' | translate"
            [disabled]="isReadonly || !keyImages.length"
            [matTooltip]="'ImageKey_ImageRowCountDetails' | translate"
            matTooltipShowDelay="500"
            [(value)]="layoutNumber"
            (selectionChange)="selectRow(layoutNumber)"
        >
            @for (item of [1, 2, 3, 4, 5]; track item) {
                <mat-option [value]="item">
                    {{ item }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <div class="delete-all-button-wrapper">
        <button
            mat-button
            class="search-panel-button"
            type="button"
            [matTooltip]="'ImageKey_DeleteAllDetails' | translate"
            matTooltipShowDelay="500"
            [disabled]="isReadonly || !keyImages.length"
            (click)="deleteImagesFromRepository()"
        >
            {{ "ImageKey_DeleteAll" | translate }}
        </button>
    </div>
</div>
